import { CloudFlowNodeType, CloudFlowProvider } from "@doitintl/cmp-models";
import ApiOutlinedIcon from "@mui/icons-material/ApiOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ForkRightRoundedIcon from "@mui/icons-material/ForkRightRounded";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import TransformIcon from "@mui/icons-material/Transform";
import { Box } from "@mui/material";

import AWSLogoLight from "../../../../assets/aws-logo.svg";
import AWSLogoDark from "../../../../assets/aws-logo-dark-mode.svg";
import DoitLogo from "../../../../assets/doit-logo-hero-square.svg";
import GCPLogo from "../../../../assets/gcp-logo.svg";
import { cmpBaseColors } from "../../../../cmpBaseColors";
import { useDarkThemeCheck } from "../../../../Components/hooks/useDarkThemeCheck";
import { type RFNode } from "../../types";

const ActionIcon = ({ isDarkMode, provider }: { isDarkMode: boolean; provider?: CloudFlowProvider }) => {
  const AWSLogo = isDarkMode ? AWSLogoDark : AWSLogoLight;
  switch (provider) {
    case CloudFlowProvider.AWS:
      return (
        <Box
          component="img"
          src={AWSLogo}
          sx={{
            width: 18,
            height: 18,
          }}
        />
      );
    case CloudFlowProvider.GCP:
      return (
        <Box
          component="img"
          src={GCPLogo}
          sx={{
            width: 18,
            height: 18,
          }}
        />
      );
    case CloudFlowProvider.DoiT:
      return (
        <Box
          component="img"
          src={DoitLogo}
          sx={{
            width: 18,
            height: 18,
          }}
        />
      );
    default:
      return <ApiOutlinedIcon color="primary" width={18} height={18} />;
  }
};

export const NodeIcon = ({ node }: { node: RFNode }) => {
  const isDarkMode = useDarkThemeCheck();
  switch (node.nodeData.type) {
    case CloudFlowNodeType.ACTION:
      return (
        <ActionIcon
          isDarkMode={isDarkMode}
          provider={(node as RFNode<CloudFlowNodeType.ACTION>).nodeData.parameters?.provider as CloudFlowProvider}
        />
      );
    case CloudFlowNodeType.CONDITION:
      return <ForkRightRoundedIcon color="primary" fontSize="small" />;
    case CloudFlowNodeType.DATETIME_TRANSFORM:
      return <ManageHistoryIcon color="primary" fontSize="small" />;
    case CloudFlowNodeType.FILTER:
      return <FilterAltIcon color="primary" fontSize="small" />;
    case CloudFlowNodeType.TRANSFORMATION:
      return <TransformIcon color="primary" fontSize="small" />;
    case CloudFlowNodeType.TRIGGER:
    case CloudFlowNodeType.MANUAL_TRIGGER:
    case CloudFlowNodeType.START_STEP:
      return <TimerOutlinedIcon color="primary" fontSize="small" />;
    default:
      return null;
  }
};

export const RoundedNodeIcon = ({ node }: { node: RFNode }) => {
  const isDarkMode = useDarkThemeCheck();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        width: 26,
        height: 26,
        background: isDarkMode ? cmpBaseColors.backgroundDark : cmpBaseColors.backgroundLight,
      }}
    >
      <NodeIcon node={node} />
    </Box>
  );
};
